const type = 'SET_ACCOUNT_PROGRAM_TYPES_LOADING';

const setAccProgramTypesLoading = (data) => ({
  data,
  type,
});

export { type };
export default setAccProgramTypesLoading;
